module.exports = __webpack_public_path__ + "static/img/meg2.d8d82bd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/staff/meg2.jpg
// module id = 209
// module chunks = 1